import { TableBody } from '@mui/material';
import React, { FC } from 'react';
import { ActionType } from '../../../api/vault/assetStatus/interfaces';
import JobListTableRow from './JobListTableRow';
import { IFormattedAssetStatus, JobTab } from '../../../state/jobStatus';
import { ILiveStreamJob } from '../../../api/vault/livestream';
import { ISecurityProfile } from '../../../api/vault/securityProfiles';

interface IProps {
  jobs: IFormattedAssetStatus[],
  liveEvents: ILiveStreamJob[],
  jobTab: JobTab,
  isExchange: boolean,
  onJobCancel: (jobId: string) => void,
  onRetryAssetJob: (assetid: string, actionType: ActionType, jobId: string, assetName: string) => void,
  isRetryDisabled: boolean,
  securityProfilesMapping: ISecurityProfile[],
  isSuperAdmin: boolean,
}
const JobListTableBody: FC<IProps> = (props: IProps) => {
  const {
    jobs, isExchange, onJobCancel, onRetryAssetJob,
    isRetryDisabled, jobTab, liveEvents, securityProfilesMapping, isSuperAdmin,
  } = props;

  if (jobTab === JobTab.LiveEvents || jobTab === JobTab.ExchangeEvents) {
    if (!liveEvents) return null;
    return (
      <TableBody className="Job-List-Table-Body" data-job-list="JobListTable">
        {liveEvents.map((liveEvent, i) => (
          <JobListTableRow
            key={`${liveEvent._id}${i}`}
            jobTab={jobTab}
            liveEvent={liveEvent}
            job={null}
            isExchange={isExchange}
            onJobCancel={null}
            onRetryAssetJob={null}
            isRetryDisabled
            securityProfilesMapping={securityProfilesMapping}
            isSuperAdmin={isSuperAdmin}
          />
        ))}
      </TableBody>
    );
  }
  if (!jobs) return null;
  return (
    <TableBody className="Job-List-Table-Body" data-job-list="JobListTable">
      {jobs.map((job, i) => (
        <JobListTableRow
          key={`${job._id}${i}`}
          jobTab={jobTab}
          liveEvent={null}
          job={job}
          isExchange={isExchange}
          onJobCancel={(jobId) => onJobCancel(jobId)}
          onRetryAssetJob={(assetId, actionType, jobId, assetName) => onRetryAssetJob(assetId, actionType, jobId, assetName)}
          isRetryDisabled={isRetryDisabled}
          securityProfilesMapping={securityProfilesMapping}
          isSuperAdmin={isSuperAdmin}
        />
      ))}
    </TableBody>
  );
};

export default JobListTableBody;
